import styled from 'styled-components'

const TextArea = styled.textarea`
  background: var(--off-white);
  padding: 0.75rem;
  line-height: 125%;
  overflow-y: auto;
  resize: none;
  min-height: 10rem;
  flex: 1;
  border: 1px solid transparent;
  &:focus {
    border: 1px solid var(--blue);
  }
  &:last-child {
    margin-bottom: 1.25rem;
  }
`

export default TextArea



// WEBPACK FOOTER //
// ./src/components/TextArea.js